import { UserType } from '@generatedTypes/data-contracts';
import { Navigate } from 'react-router-dom';
import { useGetLoggedInUser } from '@services/api/users';

export interface AuthorizedUserTypesProps {
  userTypes: UserType[];
  children: React.ReactNode;
  redirectTo?: string;
}

export const AuthorizedUserTypes = ({ userTypes, children, redirectTo = `/404` }: AuthorizedUserTypesProps) => {
  const { user } = useGetLoggedInUser();

  const isUserTypeAuthorized = userTypes.includes(user?.type ?? UserType.None);

  if (user && !isUserTypeAuthorized) {
    return <Navigate to={redirectTo} />;
  }

  return <>{children}</>;
};
